import api from '@/services/Api';

class Reports {
  static all(params) {
    return api.get('/awards/reports', {
      params,
    });
  }

  static get(id, params) {
    return api.get(`/awards/reports/${id}`, {
      params,
    });
  }

  static update(id, payload) {
    return api.put(`/awards/reports/${id}`, payload);
  }

  static submit(id) {
    return api.post(`/awards/reports/${id}/submit`);
  }
}

export default Reports;
